import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';
import {WEEKDAYS_SHORT} from '../../i18n/timeLocaleData';

const styles = {
  wrapper: {
    padding: 15
  },
};

@injectIntl
class NpsByDayOfWeekBarChart extends Component {
  render() {
    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const npsByDayOfWeek = answersReport ? answersReport.npsByDayOfWeek : [];

    const categories = npsByDayOfWeek.map(item => {
      return WEEKDAYS_SHORT[intl.locale][item.dayOfWeek%7];
    });
    const data = npsByDayOfWeek.map(item => item.nps);

    const chartConfig = {
      chart: {
        type: 'column',
        height: this.props.height-(styles.wrapper.padding*2),
        width: this.props.width-(styles.wrapper.padding*2),
        marginLeft: 20,
        marginRight: 20,
      },
      title: {
        text: intl.formatMessage({id: 'nps'}),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          },{
            count: npsByDayOfWeek[index].count,
          });
        },
      },
      xAxis: {
        categories,
        title: {
          text: intl.formatMessage({id: 'dayOfWeek'}),
        },
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            format: '{y:.0f}',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: this.props.uniqueId}}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  NpsByDayOfWeekBarChart,
  graphql`
    fragment NpsByDayOfWeekBarChart_answersReport on AnswersReport {
      npsByDayOfWeek {
        dayOfWeek
        nps
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/NpsByDayOfWeekBarChart/NpsByDayOfWeekBarChart.js